<template>
    <v-btn color="primary" @click="openViewerWeb(model)" :disabled="sending">
        <v-icon left> mdi-eye </v-icon>
        Ver imágenes
    </v-btn>
</template>
<script>

import StudyRequest from "@/core/request/StudyRequest";

export default {
    props: {
        send: Function,
        sending: Boolean,
        idStudy: String
    },
    data() {
        return {
        }
    },
    created() {

    },
    methods: {
        openViewerWeb() {

            this.send();

            StudyRequest.generateLinkToViewImages(this.idStudy).then((response) => {
                let { data, code } = response.data;
                if (code == 200) {
                    window.open(data, "_blank");
                } else {
                    this.$utilFront.notifications("Error de conexión al servidor de imágenes", "ERROR");
                }
            }).catch((e) => {
                this.$utilFront.errorhttp(e);
            }).finally(() => {
                this.send();
            });

        }
    },
};
</script>
